import { isExecutive, type Role } from "@packages/core/session/roles.ts";

export const ANALYTICS_ACCESS: readonly Role[] = [isExecutive];
